import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":""}},[_c('div',{style:({position: 'absolute', top:'0', right:0})},[_c('dark-mode')],1),_c('gallery-menu',{attrs:{"nav":_vm.menu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }